export function telValidation(err = "Digite um telefone válido.") {
  return (v) => {
    if (!v) return true;
    return /^\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/.test(v) || err;
  };
}
